'use strict';

var styled = require('styled-components');
var palette = require('../../theme/palette.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const stylesByVariant = {
    body: styled.css `
    font-weight: ${({ theme }) => theme.designTokens.textBodyFontWeight};
    font-size: ${({ theme }) => theme.designTokens.textBodyFontSize};
    line-height: ${({ theme }) => theme.designTokens.textBodyLineHeight};
  `,
    'body-light': styled.css `
    font-weight: ${({ theme }) => theme.designTokens.textBodyLightFontWeight};
    font-size: ${({ theme }) => theme.designTokens.textBodyLightFontSize};
    line-height: ${({ theme }) => theme.designTokens.textBodyLightLineHeight};
  `,
    'body-lighter': styled.css `
    font-weight: ${({ theme }) => theme.designTokens.textBodyLighterFontWeight};
    font-size: ${({ theme }) => theme.designTokens.textBodyLighterFontSize};
    line-height: ${({ theme }) => theme.designTokens.textBodyLighterLineHeight};
  `,
    caption: styled.css `
    display: inline-block;
    font-weight: ${({ theme }) => theme.designTokens.textCaptionFontWeight};
    font-size: ${({ theme }) => theme.designTokens.textCaptionFontSize};
    line-height: ${({ theme }) => theme.designTokens.textCaptionLineHeight};
    & > & {
      font-size: 0.8125em;
      line-height: 1em;
      vertical-align: baseline;
    }
  `,
};
const propsToOmitInDOM = new Set([
    'variant',
    'textAlign',
    'textDecoration',
    'textOverflow',
    'textTransform',
]);
const Span = styled__default.default.span.withConfig({
    shouldForwardProp: prop => !propsToOmitInDOM.has(prop),
}) `
  margin: 0;
  font: inherit;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.designTokens.textFontFamily};
  color: ${({ theme, color }) => (color ? palette.textColors[color] : theme.designTokens.textTextColor)};
  letter-spacing: ${({ theme }) => theme.designTokens.textLetterSpacing};
  vertical-align: middle;
  text-align: ${({ textAlign: align }) => align};
  text-decoration: ${({ textDecoration: decoration }) => decoration};
  text-overflow: ${({ textOverflow }) => textOverflow};
  ${({ textOverflow }) => (textOverflow === 'clip' || textOverflow === 'ellipsis') &&
    styled.css `
      white-space: nowrap;
      overflow-x: hidden;
    `}
  text-rendering: optimizeLegibility;
  text-transform: ${({ textTransform }) => textTransform};
  ${({ variant }) => stylesByVariant[variant]}
`;
const Styled = {
    Span,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
